// extracted by mini-css-extract-plugin
module.exports = {"component":"HistoryMessage_component__ECk17","message":"HistoryMessage_message__3UpQT"};